import {parseDateWithFormat} from '@shared/dateUtils';
import type {EvStatsFor30Days} from '@di-shared/api/di/__generated_eu';
import {roundToFixed} from '@di-shared/utils';

export const EV_DAILY_GRAPH_MAX_LENGTH = 30;

export function useEnergyUsageDaily({evDailyData}: {evDailyData: EvStatsFor30Days}) {
  const isDailyEnergyUsageNone =
    evDailyData.evStatistics.totalPowerConsumption === 0 &&
    evDailyData.evStatistics.totalRegenPower === 0 &&
    evDailyData.evStatistics.avrMileage === 0;

  const verifiedEvDrivingInfoList = evDailyData.evDrivingInfoList
    .map((ev) => {
      const verifiedDate = parseDateWithFormat(ev.date);
      if (!verifiedDate) {
        throw new Error('evDrivingInfoList date parse error');
      }
      return {
        ...ev,
        verifiedDate,
      };
    })
    .sort((a, b) => +a.date - +b.date);

  /**
   * 전력 소비량 가공
   * @link https://jira.hmg-corp.io/browse/DRIVINGINS-789
   * evDailyData.evDrivingInfoList.reduce((acc, cur) => acc + cur.powerConsumption, 0)
   * 더한 값과 totalPowerConsumption이 일치하지 않음
   */
  const avgPowerConsumption = roundToFixed(evDailyData.evStatistics.totalPowerConsumption / EV_DAILY_GRAPH_MAX_LENGTH, 2);
  const minPowerConsumption = evDailyData.evDrivingInfoList.filter((ev) => ev.powerConsumption !== 0).length
    ? Math.min(...evDailyData.evDrivingInfoList.filter((ev) => ev.powerConsumption !== 0).map((ev) => ev.powerConsumption))
    : 0;
  const maxPowerConsumption = Math.max(...evDailyData.evDrivingInfoList.map((ev) => ev.powerConsumption));

  // 평균 전비 가공
  const minAvrMileage = evDailyData.evDrivingInfoList.filter((ev) => ev.avrMileage !== 0).length
    ? Math.min(...evDailyData.evDrivingInfoList.filter((ev) => ev.avrMileage !== 0).map((ev) => ev.avrMileage))
    : 0;
  const maxAvrMileage = Math.max(...evDailyData.evDrivingInfoList.map((ev) => ev.avrMileage));

  return {
    isDailyEnergyUsageNone,
    verifiedEvDrivingInfoList,
    avgPowerConsumption,
    minPowerConsumption,
    maxPowerConsumption,
    minAvrMileage,
    maxAvrMileage,
  };
}
